// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPushpinDisableOutlinedSvg from "@fishx/icons-svg/es/asn/PPushpinDisableOutlined";
import FishxIcon from '../components/FishxIcon';

var PPushpinDisableOutlined = function PPushpinDisableOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPushpinDisableOutlinedSvg
  }));
};

PPushpinDisableOutlined.displayName = 'PPushpinDisableOutlined';
export default React.forwardRef(PPushpinDisableOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPushpinDisableOutlined.js
// module id = 3553
// module chunks = 0